(function () {
    'use strict';
    angular.module('doclr.cities.api', [])
        .factory('Cities', function ($http, $q) {
            let cachedCities = [];
            const Cities = {};
            Cities.load = function () {
                if (cachedCities && cachedCities.length > 0) {
                    const deferred = $q.defer();
                    deferred.resolve(cachedCities);
                    return deferred.promise;
                }

                return $http.get('/api/public/cities')
                    .then(function (response) {
                        cachedCities = response.data;
                        return cachedCities;
                    });
            };

            Cities.search = function(zoekTerm){
                if (!zoekTerm || !cachedCities) {
                    return [];
                }

                function isNumber(n) {
                    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
                }

                if (isNumber(zoekTerm)) {
                    return cachedCities.filter(function (city) {
                        return city.postalCode.toLowerCase().startsWith(zoekTerm.toLowerCase());
                    });
                }
                return cachedCities.filter(function (city) {
                    return city.cityNl.toLowerCase().startsWith(zoekTerm.toLowerCase()) || city.cityFr.toLowerCase().startsWith(zoekTerm.toLowerCase());
                });
            };
            return Cities;
        });
})();
